export default __webpack_public_path__ + "static/media/Underrated_Big.05273f13.svg";